// 수거 주소 시트 (회사명 메뉴 · 모바일 더보기) — 기사가 번호판·등록증을 수거하는 곳.
// PUT /settings/company-info 는 body 에 없는 칸을 '' 로 덮어쓴다 → 먼저 GET /settings/company 로 읽고
// 업체 정보 9키를 전부 되돌려 보낸다(pickupAddress 단독 전송 금지 — api.putCompanyInfo 도 막는다).
// 열려 있을 때만 mount 한다. props: { user, showToast, onClose }
import React, { useState, useEffect } from 'react';
import { S } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import { describeSimpleError } from '../../simple/errors';
import { getCompany, putCompanyInfo } from '../api';

function str(v) { return v == null ? '' : String(v); }

function PickupAddressSheet(props) {
  var t = useT();
  var user = props.user || {};
  var cid = user.activeCompanyId || user.companyId;
  var st = useState(null);
  var company = st[0], setCompany = st[1];
  var st2 = useState('');
  var value = st2[0], setValue = st2[1];
  var st3 = useState(false);
  var busy = st3[0], setBusy = st3[1];
  var showToast = props.showToast;

  useEffect(function () {
    var alive = true;
    getCompany(cid).then(function (c) {
      if (!alive) return;
      setCompany(c || {});
      setValue(str(c && c.pickupAddress));
    }).catch(function (err) {
      if (alive && showToast) showToast(describeSimpleError(t, err), 'err');
    });
    return function () { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cid]);

  var save = function () {
    if (!company || busy) return;
    setBusy(true);
    putCompanyInfo({
      companyId: cid, bizNo: str(company.bizNo), ceo: str(company.ceo), address: str(company.addrKr),
      bizType: str(company.bizType), bizItem: str(company.bizItem), tel: str(company.tel), email: str(company.email),
      pickupAddress: value.trim()
    }).then(function () { props.onClose(); })
      .catch(function (err) { setBusy(false); if (showToast) showToast(describeSimpleError(t, err), 'err'); });
  };

  return (<ConfirmSheet open title={t('carCancelPickupSection')} confirmLabel={t('actionSave')}
    onConfirm={save} onClose={props.onClose}>
    <input type="text" style={S.input} data-testid="pickup-input" value={value} disabled={!company}
      aria-label={t('carCancelPickupSection')} onChange={function (e) { setValue(e.target.value); }} />
  </ConfirmSheet>);
}

export default PickupAddressSheet;
